import { apiClient } from '../../api/client'
import type { TrackerCheck, TrackerCheckRequest, TrackerRevisionStrategies } from '../../api/types/portfolio-tracker.types'
import type { StrategyDirection } from '../../api/types/trading-strategy.types'

const BASE_URL = '/api/portfolio-tracker'

// GET /api/portfolio-tracker/revisions/{revisionId}/strategies?side={side} - A revision's strategies on one side
export const getTrackerRevisionStrategies = async (
  revisionId: string,
  side: StrategyDirection,
): Promise<TrackerRevisionStrategies> => {
  const response = await apiClient.get<TrackerRevisionStrategies>(`${BASE_URL}/revisions/${revisionId}/strategies`, {
    params: { side },
  })
  return response.data
}

// POST /api/portfolio-tracker/check - A portfolio worked out from the signals and from the builder's trades
export const checkTrackerPortfolio = async (request: TrackerCheckRequest): Promise<TrackerCheck> => {
  const response = await apiClient.post<TrackerCheck>(`${BASE_URL}/check`, request)
  return response.data
}
